import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ZyYoutubeVideoNodeView from './zyyoutubevideo-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyYoutubeVideo: {
            insertZyYoutubeVideo: (options?: InsertZyYoutubeVideoOptions) => ReturnType;
        };
    }
}

export interface InsertZyYoutubeVideoOptions {
    id?: string;
    caption?: string;
    link?: string;
}

export const ZyYoutubeVideoNodeHeadless = Node.create({
    name: 'zyYoutubeVideo',

    group: 'block',

    atom: true,

    selectable: true,

    draggable: true,

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: element => element.getAttribute('data-id'),
                renderHTML: attributes => ({
                    'data-id': attributes.id,
                }),
            },
            caption: {
                default: '',
                parseHTML: element => element.getAttribute('data-caption') || '',
                renderHTML: attributes => ({
                    'data-caption': attributes.caption,
                }),
            },
            link: {
                default: '',
                parseHTML: element => element.getAttribute('data-link') || '',
                renderHTML: attributes => ({
                    'data-link': attributes.link,
                }),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-type="zy-youtube-video"]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(HTMLAttributes, {
                'data-type': 'zy-youtube-video',
                class: 'zy-youtube-video-container',
            }),
        ];
    },

    addCommands() {
        return {
            insertZyYoutubeVideo:
                (options: InsertZyYoutubeVideoOptions = {}) =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: this.name,
                        attrs: {
                            caption: options.caption || '',
                            link: options.link || '',
                        },
                    });
                },
        };
    },
});

export const ZyYoutubeVideoNode = ZyYoutubeVideoNodeHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyYoutubeVideoNodeView);
    },
});

export default ZyYoutubeVideoNode;
